"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { Skeleton as t } from "../Skeleton/Skeleton.mjs";
import { useIconLoader as n } from "../../../utils/hooks.mjs";
import { forwardRef as r } from "react";
import { jsx as i } from "react/jsx-runtime";
import { cva as a } from "class-variance-authority";
//#region src/components/atoms/Icon/Icon.tsx
var o = a("", {
	variants: { variant: {
		blue: "[&_path]:fill-blue-600",
		pink: "[&_path]:fill-pink-500",
		yellow: "[&_path]:fill-yellow-500",
		black: "[&_path]:fill-black"
	} },
	defaultVariants: { variant: "blue" }
}), s = (e) => "icon" in e && e.icon !== void 0, c = (e) => "name" in e && e.name !== void 0, l = r((r, a) => {
	let { className: l, width: u, height: d, ...f } = r, p = c(r) ? r.name : void 0, m = c(r) ? r.variant : void 0, { component: h, isLoading: g, hasError: _ } = n(p, m), v;
	s(r) ? v = r.variant ? o({ variant: r.variant }) : void 0 : c(r) && (v = void 0);
	let y = e(v, l);
	if (s(r)) {
		let e = r.icon;
		return /* @__PURE__ */ i(e, {
			ref: a,
			className: y,
			width: u,
			height: d,
			...f
		});
	}
	if (c(r) && _) return /* @__PURE__ */ i("div", {
		className: e("flex items-center justify-center text-red-500 border border-red-200 rounded", y),
		style: {
			width: u,
			height: d
		},
		role: "img",
		"aria-label": `Failed to load icon: ${r.name}`,
		title: `Icon "${r.name}" failed to load`,
		children: /* @__PURE__ */ i("span", {
			className: "text-xs select-none",
			"aria-hidden": "true",
			children: "⚠️"
		})
	});
	if (c(r) && g) return /* @__PURE__ */ i(t, {
		width: u,
		height: d,
		variant: "circular",
		"data-testid": "skeleton"
	});
	if (c(r) && h) {
		let e = h;
		try {
			return /* @__PURE__ */ i(e, {
				ref: a,
				className: y,
				width: u,
				height: d,
				role: "img",
				"aria-label": r["aria-label"] || r.name,
				...f
			});
		} catch (e) {
			return console.error("Error rendering DynamicIcon:", e), null;
		}
	}
	return null;
});
l.displayName = "Icon";
//#endregion
export { l as Icon, l as default };
